import { render, staticRenderFns } from "./IntransitGoods.vue?vue&type=template&id=7c01a4d0&"
import script from "./IntransitGoods.vue?vue&type=script&lang=js&"
export * from "./IntransitGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports